// translations/pages/events/fr.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageFR = {
  title: 'Événements',
  upcoming: 'Événements à venir',
  past: 'Événements passés',
  all: 'Tous les événements',
  items: {
    wikki26: {
      title: 'WiKKI26 – Conférence de Wildau sur l’intelligence artificielle',
      description: 'pAIoneer Labs était présent en tant qu’exposant à la Technische Hochschule Wildau. Sur le stand, il était question de la manière dont des infrastructures d’IA locales se mettent en place dans les entreprises et les organisations : souveraineté des données, protection des données dès la conception et IA conforme au droit, sans dépendance inutile vis-à-vis de solutions cloud externes.'
    }
  }
};
